import React, { ComponentType, useState, FC } from 'react'
import Breakpoint from './Breakpoint'
import { Breakpoints } from 'styles/breakpoints'
import MountHandle from 'components/MountHandle'

export function withBreakpoint<OwnProps, PropName extends string>(
  on: Breakpoints,
  propName: PropName
): (
  Component: ComponentType<{ [key in PropName]: boolean } & OwnProps>
) => FC<OwnProps> {
  return Component =>
    // eslint-disable-next-line react/display-name
    (props: OwnProps) => {
      const [isEnabled, setIsEanabled] = useState(false)

      return (
        <>
          <Breakpoint on={on}>
            <MountHandle
              onMount={() => setIsEanabled(true)}
              onUnmount={() => setIsEanabled(false)}
            />
          </Breakpoint>
          <Component
            {...props}
            {...({ [propName]: isEnabled } as { [key in PropName]: boolean })}
          />
        </>
      )
    }
}
